<template>
  <li class="entry-item">
    <a :href="entry.url">
      <div class="entry-photo">
        <img v-if="entry.entry_img_url" v-lazy="entry.entry_img_url" />
        <img v-else :src="notfoundimage" />
      </div>
      <div class="entry-parts-wrapp">
        <h2 class="entry-title">{{ entry.title }}</h2>
        <div class="entry-date">{{ entry.entry_date }}</div>
      </div>
    </a>
  </li>
</template>

<script>
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload,{
  loading: 'https://www.j-cast.com/assets_common/img/common/icon-photo-m.png'
})
export default {
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  computed: {
    notfoundimage() {
      if(this.entry.url.match(/tv/)){
        return 'https://www.j-cast.com/assets_common/img/common/article-noimage_tv.png' 
      }

      if(this.entry.url.match(/trend/)){
        return 'https://www.j-cast.com/assets_common/img/common/article-noimage_trend.png' 
      }

      if(this.entry.url.match(/kaisha/)){
        return 'https://www.j-cast.com/assets_common/img/common/article-noimage_kaisha.png' 
      }

      return 'https://www.j-cast.com/assets_common/img/common/article-noimage_news.png'
    }
  }
}
</script>
